class TrackingCategoryController extends AbstractEntityEditController
	@register()
	@inject 'trackingCategory',
		'TrackingCategoryRepository'
		'BACKEND_TRACKING_CATEGORY_LOGIN_FLOW_PLACEMENT'
		'translate'

	initialize: ->
		@mainCrud.entityType = 'general.tracking_category'
		@mainCrud.isNewEntity = !@trackingCategory.id?

		if !@mainCrud.isNewEntity
			@mainCrud.entityTitle = @trackingCategory.name
			@trackingCategory.tracking_category_options =
				_.map @trackingCategory.tracking_category_options, (trackingCategoryOption) =>
					trackingCategoryOption.isNewEntity = false

					return trackingCategoryOption
		else
			@mainCrud.entityTitle = 'general.tracking_category.new'
			@trackingCategory.tracking_category_options = []

		@loginFlowPlacements = _.map(
			@BACKEND_TRACKING_CATEGORY_LOGIN_FLOW_PLACEMENT,
			(value) => {
				id: value
				name: @translate("general.tracking_category.login_flow_placement.#{value}")
			}
		)

		@sortTrackingCategoryOptions()

	save: ->
		@mainCrud.saving = true

		@TrackingCategoryRepository
			.save @trackingCategory, @mainCrud.isNewEntity
			.then (response) =>
				@trackingCategory = response.data
				@sortTrackingCategoryOptions()
				@afterSave response
			.catch (result) =>
				@handleErrors result

	delete: ->
		@deleteEntity @TrackingCategoryRepository, @trackingCategory

	addTrackingCategoryOption: ->
		@trackingCategory.tracking_category_options.push {name: null, isNewEntity: true}

		@main_form.$setDirty()

	removeTrackingCategoryOption: (index) ->
		@trackingCategory.tracking_category_options.splice index, 1

		@main_form.$setDirty()

	sortTrackingCategoryOptions: ->
		# Sorting here instead of ng-repeat orderBy filter because, the filter sorts on input (instantly), we need on save
		@trackingCategory.tracking_category_options = _.sortBy(
			@trackingCategory.tracking_category_options,
			(trackingCategoryOption) -> trackingCategoryOption.name
		)
